<template>
  <div class="wrap1">
    <div class="wrap1-top">
      <el-tabs v-model="activeName">
        <el-tab-pane v-for="item in tabs" :key="item.text" :label="$t(item.text)" :name="item.active">
          <component v-if="item.active === activeName" :is="item.comp" />
        </el-tab-pane>
      </el-tabs>
      <div class="btn">
        <el-button class="btn-title" size="small" @click="goToDownload">{{ $t('pay.slip.1') }}</el-button>
        <el-button class="btn-title" size="small" @click="goToSafe" v-if="$p('menu.payroll.scheme.setting')">{{
          $t('i18n.9bc68f8228ff4aa78c9d60a5e5de6056')
        }}</el-button>
        <el-button
          class="btn-title"
          size="small"
          icon="el-icon-plus"
          @click="goToDetail(false, '1')"
          v-if="$p('menu.payroll.scheme.edit')"
          >{{ $t('pay_slip_4') }}</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: this.$route.query.active || '1',
      tabs: [
        {
          comp: () => import('./component/template.vue'),
          active: '1',
          text: 'pay_slip_1' // 工资条模板
        },
        {
          comp: () => import('./component/due-out.vue'),
          active: '2',
          text: 'pay_slip_2' // 待发工资条
        },
        {
          comp: () => import('./component/issued.vue'),
          active: '3',
          text: 'pay_slip_3' // 已发工资条
        }
      ],
      // 方案列表
      wageList: [],
      year: ''
    }
  },
  methods: {
    // 跳转下载工资条页面
    goToDownload() {
      this.$router.push({ path: 'download-pay-slip' })
    },
    // 工资条安全性
    goToSafe() {
      this.$router.push({ path: 'safe-pay-slip' })
    },
    goToDetail(item, state) {
      // 跳转配置页
      this.$router.push({ path: '/payroll/edit-pay-slip', query: { state } })
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap1 {
  &-top {
    height: 100%;
    width: 100%;
    position: relative;
    .btn {
      position: absolute;
      top: 8px;
      right: 24px;
      &-title {
        &:last-child {
          color: #5D51DA;
          border-color: #5D51DA;
        }
      }
    }
  }
  /deep/ &-content {
    height: 100%;
    li {
      height: 70px;
      border: 1px solid #d9d9d9;
      border-radius: 4px;
      margin-bottom: 16px;
      padding: 0 24px;
      color: #262626;
      display: flex;
      align-items: center;
      .pay-info {
        flex: 1;
        display: flex;
        align-items: center;
        .name {
          display: inline-block;
          max-width: 450px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          font-weight: 500;
          font-size: 16px;
          color: #262626;
        }
        span {
          margin-right: 10px;
        }
      }
      .item-btn {
        display: none;
      }
      &:hover {
        cursor: pointer;
        border: 1px solid #8ac8ff;
        .item-btn {
          display: block;
        }
      }
    }
  }
  /deep/ .el-tabs {
    height: 100%;
    width: 100%;
    padding: 0;
    .el-tabs__header {
      line-height: 48px;
      height: 48px;
    }
    .el-tabs__nav-wrap {
      padding: 0 24px;
    }
    .el-tabs__content {
      height: calc(100% - 63px);
      overflow-y: auto;
      padding: 0 24px;
    }
  }
}
/deep/ .not-data {
  text-align: center;
  img {
    display: block;
    margin: 0 auto;
    padding-top: 200px;
  }
  span {
    color: #8c8c8c;
    font-weight: 400;
  }
}
</style>
